export default __webpack_public_path__ + "static/media/skill_1.33ff4831.png";